var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneStriked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29289 1.29289C1.68342 0.902369 2.31658 0.902369 2.70711 1.29289L38.7071 37.2929C39.0976 37.6834 39.0976 38.3166 38.7071 38.7071C38.3166 39.0976 37.6834 39.0976 37.2929 38.7071L32.9841 34.3983C32.8898 35.5786 32.3789 36.6922 31.5355 37.5355C30.5979 38.4732 29.3261 39 28 39H12C10.6739 39 9.40215 38.4732 8.46447 37.5355C7.52678 36.5979 7 35.3261 7 34V8.41421L1.29289 2.70711C0.902369 2.31658 0.902369 1.68342 1.29289 1.29289ZM9 10.4142V34C9 34.7957 9.31607 35.5587 9.87868 36.1213C10.4413 36.6839 11.2044 37 12 37H28C28.7956 37 29.5587 36.6839 30.1213 36.1213C30.6839 35.5587 31 34.7957 31 34V32.4142L9 10.4142ZM12 3C11.5463 3 11.1219 3.09907 10.7395 3.27682C10.2387 3.50962 9.64399 3.29235 9.41118 2.79153C9.17838 2.29071 9.39565 1.69599 9.89647 1.46318C10.5381 1.16493 11.2497 1 12 1H28C29.3261 1 30.5979 1.52678 31.5355 2.46447C32.4732 3.40215 33 4.67392 33 6V24C33 24.5523 32.5523 25 32 25C31.4477 25 31 24.5523 31 24V6C31 5.20435 30.6839 4.44129 30.1213 3.87868C29.5587 3.31607 28.7956 3 28 3H22C22.5523 3 23 3.44772 23 4C23 4.55228 22.5523 5 22 5H18C17.4477 5 17 4.55228 17 4C17 3.44772 17.4477 3 18 3H12ZM20 29C20.5523 29 21 29.4477 21 30V30.02C21 30.5723 20.5523 31.02 20 31.02C19.4477 31.02 19 30.5723 19 30.02V30C19 29.4477 19.4477 29 20 29Z",
    fill: "#F46B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneStriked);
export default __webpack_public_path__ + "static/media/PhoneStriked.26234457a6c5cb94b776f6158c71bd5e.svg";
export { ForwardRef as ReactComponent };